import type { TOC } from '@ember/component/template-only';

import WizardStartingComponent from 'webapp/components/wizard/starting';

const WizardStartingRouteTemplate: TOC<object> = <template><WizardStartingComponent /></template>;

export default WizardStartingRouteTemplate;
